//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"CanUseOrientationTool",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[0,"ConstraintPlane",1,"CoordinateSystem",0],[0,"Curve",0,"Polyline",0],[0,"DrawingPlane",1,"Plane",0],[0,"DrawingPlaneOption",1,0],[0,"HasPlaneConstraint",1,0],[0,"IsPeriodic",1,0],[0,"MovementMethod",1,0],[0,"MovementPlane",1,"Plane",0],[0,"MovementVector",1,"Direction",0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0],[0,"WCSOption",1,0]],[[["polyline"],"EditPolyline",{},1,0],[["afterIndex"],"InsertPoint",{},1,0],[[],"Evaluate",{},0,0],[[],"UpdateOnConstraintPlane",{},0,0]],[]];
SPLM.Features.PolylineBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PolylineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PolylineBuilder.DrawingPlaneOptions = Object.freeze({
    "View" : "View", "XY" : "XY", "YZ" : "YZ", "XZ" : "XZ", "General" : "General"});

SPLM.Features.PolylineBuilder.MovementMethodType = Object.freeze({
    "WCS" : "WCS", "View" : "View", "Vector" : "Vector", "Plane" : "Plane", "Segment" : "Segment"});

SPLM.Features.PolylineBuilder.WCSOptionType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "YZ" : "YZ", "XZ" : "XZ", "XY" : "XY"});

export default SPLM;